import { render } from "./EditProfileComponent.vue?vue&type=template&id=23b52b9c&scoped=true"
import script from "./EditProfileComponent.vue?vue&type=script&lang=js"
export * from "./EditProfileComponent.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-23b52b9c"

export default script